import type { Calendar as PrimeCalendar, CalendarSelectionMode } from "primereact/calendar";
import { forwardRef } from "react";
import type { ForwardedRef, ReactElement, RefAttributes } from "react";

import type { CalendarProps } from "./types-calendar";
import { useCalendar } from "./use-calendar";
import { CalendarView } from "./view-calendar";

function CalendarImpl(
  props: CalendarProps<CalendarSelectionMode>,
  ref: ForwardedRef<PrimeCalendar<CalendarSelectionMode>>,
) {
  const viewModel = useCalendar(props, ref);

  return <CalendarView {...viewModel} />;
}

/**
 * `Calendar` do Prime com locale pt-BR, ícones de 14 do Figma, placeholder e barra Hoje/Limpar (desligada no `inline`)
 * como padrão: a tela sobrescreve cada um por prop. Data única, intervalo (`selectionMode="range"`) e múltipla.
 */
export const Calendar = forwardRef(CalendarImpl) as (<
  TMode extends CalendarSelectionMode = "single",
>(
  props: CalendarProps<TMode> & RefAttributes<PrimeCalendar<TMode>>,
) => ReactElement) & { displayName?: string };
Calendar.displayName = "Calendar";
